module.exports = __webpack_public_path__ + "img/kubernetes_logo_blue.e1b65f80.svg";